/** Path on the Identity portal where citizens manage data shared with portals. */
const IDENTITY_UDAJE_PATH = 'obcan/moje-udaje';

/**
 * Deeplink to the citizen's "data shared with other portals" section on the
 * Identity portal, built from the configured base URL. Rendered as a markdown
 * link in the SMS subtitles; MarkdownRender opens external URLs in a new tab so
 * the authorization dialog is not closed.
 */
export const buildIdentityUdajeUrl = (identitaObcanaUrl: string) => {
	const base = (identitaObcanaUrl ?? '').replace(/\/+$/, '');
	return `${base}/${IDENTITY_UDAJE_PATH}`;
};
